// @flow
import {
  CREATE_REQUEST,
  DELETE_REQUEST,
  UPDATE_REQUEST,
} from './constants'

export function createRequest (payload: Object): Object {
  return {
    type: CREATE_REQUEST,
    payload,
  }
}

export function updateRequests (payload: Object): Object {
  return {
    type: UPDATE_REQUEST,
    payload,
  }
}

export function deleteRequest (payload: Object): Object {
  return {
    type: DELETE_REQUEST,
    payload,
  }
}
